import request from '@/utils/request'

// 查询用户成就配置列表
export function listChallengeConfig(query) {
  return request({
    url: '/biz/admin/user/challenge/config/list',
    method: 'post',
    data: query
  })
}

// 查询用户成就配置分页
export function pageChallengeConfig(query) {
  return request({
    url: '/biz/admin/user/challenge/config/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询用户成就配置详细
export function getChallengeConfig(data) {
  return request({
    url: '/biz/admin/user/challenge/config/detail',
    method: 'get',
    params: data
  })
}

// 新增用户成就配置
export function addChallengeConfig(data) {
  return request({
    url: '/biz/admin/user/challenge/config/add',
    method: 'post',
    data: data
  })
}

// 修改用户成就配置
export function updateChallengeConfig(data) {
  return request({
    url: '/biz/admin/user/challenge/config/edit',
    method: 'post',
    data: data
  })
}

// 删除用户成就配置
export function delChallengeConfig(data) {
  return request({
    url: '/biz/admin/user/challenge/config/delete',
    method: 'post',
    data: data
  })
}
